<div class="row">
  <div class="col">
    @if (appContext.isAdmin()) {
      <app-form-group label="Carrier organisation">
        <app-search [disabled]="!model['new']" required [ngModel]="model.ownerPortbaseId" [minCharacters]="3"
                    [searchFunction]="utils.findOrganisations"
                    [inputFormatter]="carrierFormatter"
                    (ngModelChange)="model.ownerPortbaseId = $event?.shortName; model.ownerFullName = $event?.fullName"
                    [resultFormatter]="utils.agentFormatter">
        </app-search>
      </app-form-group>
    }
    <app-form-group label="Customer organisation">
      <app-search [disabled]="!model['new']" required [ngModel]="model.portbaseId" [minCharacters]="3"
                  [searchFunction]="utils.findOrganisations" [inputFormatter]="customerFormatter"
                  (ngModelChange)="model.portbaseId = $event?.shortName; model.customerData = $event"
                  [resultFormatter]="utils.agentFormatter">
      </app-search>
    </app-form-group>
    <app-form-group label="Address">
      <input class="form-control" readonly [ngModel]="model.customerData?.address">
    </app-form-group>
    <app-form-group label="Zip code">
      <input class="form-control" readonly [ngModel]="model.customerData?.zipCode">
    </app-form-group>
    <app-form-group label="City">
      <input class="form-control" readonly [ngModel]="model.customerData?.city">
    </app-form-group>
    <app-form-group label="Country">
      <input class="form-control" readonly [ngModel]="model.customerData?.countryName">
    </app-form-group>
  </div>
  <div class="col-auto me-3">
    <label>Customer references</label>
  </div>
  @if (!model['new']) {
    <div class="col">
      @for (customerReferenceEntry of model.references | keyvalue; track customerReferenceEntry) {
        <div class="row mb-3">
          @if (!customerReferenceEntry.value.status || customerReferenceEntry.value.status === 'NEW') {
            <label
              class="col">
              {{ customerReferenceEntry.value.reference }}
            </label>
          }
          @if (customerReferenceEntry.value.status === 'REJECTED') {
            <label class="col text-decoration-line-through">
              {{ customerReferenceEntry.value.reference }}
              <label>(<i class="fa fa-remove ms-1 text-portbase-red"></i> Rejected,
                <app-tooltip>
                  <span><u>show reason</u></span>
                  <span class="tooltipContent">{{ customerReferenceEntry.value.rejectReason }}</span>
                </app-tooltip>
                )
              </label>
            </label>
          }
          @if (customerReferenceEntry.value.status === 'VERIFIED') {
            <label class="col">
              {{ customerReferenceEntry.value.reference }} (<i class="fa fa-check ms-1 text-success"></i> Verified)
            </label>
          }
          <div class="col-auto">
            @if (customerReferenceEntry.value.status === 'VERIFIED') {
              @if (appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor()) {
                <button class="btn btn-outline-danger ms-2" (click)="reject(model, customerReferenceEntry.value)"
                        type="button">
                  <i class="fa fa-remove me-2"></i>
                  Revoke
                </button>
              }
              @if (customerReferenceEntry.value['undoActive']) {
                <button class="btn btn-secondary ms-2"
                        (click)="undo(model, customerReferenceEntry.value)"><span
                  class="fa fa-fw fa-undo-alt"></span>
                </button>
              }
            } @else {
              @if (customerReferenceEntry.value.status === 'REJECTED') {
                @if (appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor()) {
                  <button class="btn btn-outline-info" (click)="reset(model, customerReferenceEntry.value)"
                          type="button"
                  >
                    <i class="fa fa-pencil me-2"></i>
                    Edit
                  </button>
                }
              } @else {
                <ng-container>
                  @if (appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor()) {
                    <button class="btn btn-outline-primary" (click)="verify(model, customerReferenceEntry.value)"
                            type="button"
                    >
                      <i class="fa fa-check me-2"></i>
                      Verify
                    </button>
                  }
                  @if (appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor()) {
                    <button class="btn btn-outline-danger ms-2" (click)="reject(model, customerReferenceEntry.value)"
                            type="button"
                    >
                      <i class="fa fa-remove me-2"></i>
                      Reject
                    </button>
                  }
                  @if (customerReferenceEntry.value['undoActive']) {
                    <button class="btn btn-secondary ms-2"
                            (click)="undo(model, customerReferenceEntry.value)"><span
                      class="fa fa-fw fa-undo-alt"></span>
                    </button>
                  }
                  @if (!appContext.isCommercialReleaseDeclarant() && !appContext.isCommercialReleaseEditor()) {
                    <label class="text-success"
                    >
                      Not verified
                    </label>
                  }
                </ng-container>
              }
            }
          </div>
        </div>
      }
    </div>
  }
  @if (!!model['new']) {
    <div class="col">
      <div class="row">
        <app-tags (ngModelChange)="addCustomerReference($event)"
                  [(ngModel)]="model['newReferences']"></app-tags>
      </div>
    </div>
  }
</div>
